export default {
  namespaced: true,
  state: {
    isLoading: false,
  },
  actions: {
    async setIsLoading({ commit }, isLoading) {
      commit('setIsLoading', { isLoading });
    },
  },
  mutations: {
    setIsLoading(state, { isLoading }) {
      state.isLoading = isLoading;
    },
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
  },
};
